import Flickity from 'flickity';
require('flickity-imagesloaded');

/**
 * Megadrop
 * Functions for the flickity.
 * @version 1.0.0
 * @exports Flickity
 */
export default class FlickityComponent {

	/**
	 * Constructor
	 * @public
	 */
	constructor () {
		

		let els = document.querySelectorAll('.carousel');

		els.forEach(el => {
			this._initHoverCarousel(el);
		});
	}

	_initHoverCarousel(el) {
		var flkty = new Flickity(el, {
		  cellAlign: 'center',
		  contain: true,
		  accessibility: true,
		  freeScroll: true,
		  percentPosition: true,
		  adaptiveHeight: true, 
		  setGallerySize: true,
		  cellSelector: '.carousel-cell',
		  imagesLoaded: true,
		  groupCells: true,
		  prevNextButtons: true,
		  pageDots: false
		});

			/*
		// previous
		var previousButton = document.querySelector('.flickity-prev-next-button.previous');
		previousButton.addEventListener( 'click', function() {
			flkty.previous();
		});
		// next
		var nextButton = document.querySelector('.flickity-prev-next-button.next');
		nextButton.addEventListener( 'click', function() {
			flkty.next();
		});
		*/
	}
}
